/**
 * Fetch AccessToken from Azure devops
 * @returns {Promise<string>}
 */
const fetchAccessToken = () => {
  return new Promise((resolve) => {
    window.VSS.require(['VSS/Authentication/Services'], (vssAuthService) => {
      window.VSS.getAccessToken().then((accessToken) => {
        resolve(vssAuthService.authTokenManager.getAuthorizationHeader(accessToken));
      });
    });
  });
};

export default fetchAccessToken;
